import { useState, useEffect } from 'react'
import Button from 'components/button';
import {
  TitlePopUp,
  TextPopUp,
  PopUpContainer,
} from '../custom.style'

const PopUpHealth = () => {

  const [isOpen, setIsOpen] = useState(false);

  const disabledScroll = () => {
    const html = document.querySelector("html");
    html?.classList.add("overflow-hidden");
  }

  const enabledScroll = () => {
    const html = document.querySelector("html");
    html?.classList.remove("overflow-hidden");
  }

  const handleOpen = () => {
    if (window.location.href.includes("utm_medium=PopUp") && window.location.href.includes("utm_content=QR_AvisoAlcohol") && window.location.pathname.split('/')[2] !== 'agegate') {
      setTimeout(() => {
        disabledScroll()
        setIsOpen(true)
      }, 3000)
    }
  }

  const handleClose = () => {
    enabledScroll()
    setIsOpen(false)
  }

  useEffect(() => {
    handleOpen()
  }, [])

  return (
    <PopUpContainer className={`z-50 fixed w-screen h-screen flex flex-col justify-between items-center top-0 p-5 ${isOpen ? 'flex' : 'hidden'}`}>
      <div className='w-full md:w-1/3 flex flex-col justify-between items-center h-screen'>

        <div className="w-full flex justify-end">
          <button onClick={handleClose}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.9463 11.707L24.124 1.5293C24.2998 1.35352 24.3877 1.14258 24.3877 0.896484C24.3877 0.650391 24.2998 0.439453 24.124 0.263672C23.9482 0.0878906 23.7314 0 23.4736 0C23.2275 0 23.0166 0.0878906 22.8408 0.263672L12.6807 10.4238L2.52051 0.263672C2.34473 0.0878906 2.12793 0 1.87012 0C1.62402 0 1.41309 0.0878906 1.2373 0.263672C1.06152 0.439453 0.973633 0.650391 0.973633 0.896484C0.973633 1.14258 1.06152 1.35352 1.2373 1.5293L11.415 11.707L1.2373 21.8672C1.06152 22.043 0.973633 22.2539 0.973633 22.5C0.973633 22.7461 1.06152 22.957 1.2373 23.1328C1.33105 23.2266 1.43066 23.2969 1.53613 23.3438C1.65332 23.3789 1.77051 23.3965 1.8877 23.3965C1.99316 23.3965 2.09863 23.3789 2.2041 23.3438C2.32129 23.2969 2.42676 23.2266 2.52051 23.1328L12.6807 12.9727L22.8408 23.1328C22.9346 23.2266 23.0342 23.2969 23.1396 23.3438C23.2568 23.3789 23.3682 23.3965 23.4736 23.3965C23.5908 23.3965 23.7021 23.3789 23.8076 23.3438C23.9248 23.2969 24.0303 23.2266 24.124 23.1328C24.2998 22.957 24.3877 22.7461 24.3877 22.5C24.3877 22.2539 24.2998 22.043 24.124 21.8672L13.9463 11.707Z" fill="white" />
            </svg>
          </button>
        </div>

        <div>
          <TitlePopUp className='pb-3'>POSIBLES EFECTOS DEL ALCOHOL</TitlePopUp>
          <TextPopUp>
            El consumo de alcohol es una decisión individual y afecta a las personas de distintas maneras. Algunos estudios han indicado una posible relación entre el consumo de alcohol y un mayor riesgo de padecer ciertos problemas de salud. El consumo de grandes cantidades de manera regular se ha vinculado a diversos padecimientos, como enfermedades hepáticas, enfermedades cardiovasculares, dependencia física y mayor riesgo de ciertos tipos de cáncer. El consumo compulsivo de alcohol, es decir, consumir grandes cantidades de alcohol en un período breve, es peligroso y puede causar graves problemas de salud. En algunas personas, el consumo moderado de alcohol puede incrementar varios riesgos de salud y ciertos tipos de cáncer, como el de mama. Además del ritmo de consumo, otros factores que pueden influir en el nivel de riesgo son la cantidad y frecuencia de consumo, la edad, el sexo, la genética y el estilo de vida. Por lo tanto, debes consultar con tu proveedor de servicios de salud o profesional médico para determinar si el consumo moderado de alcohol es conveniente conforme a tu situación personal de salud.
          </TextPopUp>
        </div>

        <div>
          <a href='https://www.moderationmatters.com/mx' target='_blank' rel='noreferrer'>
            <Button style={{ fontSize: '10px' }}>
              Para mayor información visita: moderationmatters.com
            </Button>
          </a>
        </div>
      </div>
    </PopUpContainer>
  )
}

export default PopUpHealth